import { createContext, useContext, useState, useCallback, lazy, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from './LanguageContext';

const AddedDialog = lazy(() =>
  import(/* webpackChunkName: "added-dialog" */ '../components/AddedDialog')
);

const ToastContext = createContext({
  showToast: () => {},
  showCartDialog: () => {},
});

export function ToastProvider({ children }) {
  const { lang } = useLanguage();
  const navigate = useNavigate();
  const [toast, setToast] = useState(null);
  const [dialog, setDialog] = useState(null);

  const showToast = useCallback((message, duration = 2500) => {
    setDialog(null);
    setToast(message);
    const timer = setTimeout(() => setToast(null), duration);
    return () => clearTimeout(timer);
  }, []);

  const showCartDialog = useCallback(() => {
    setToast(null);
    setDialog({ type: 'cart' });
  }, []);

  const closeDialog = useCallback(() => {
    setDialog(null);
  }, []);

  const goToCart = useCallback(() => {
    setDialog(null);
    navigate('/cart');
  }, [navigate]);

  return (
    <ToastContext.Provider value={{ showToast, showCartDialog }}>
      {children}
      {toast && (
        <div className="daiv-toast" role="status" aria-live="polite">
          {toast}
        </div>
      )}
      {dialog && (
        <Suspense fallback={null}>
          <AddedDialog
            type={dialog.type}
            lang={lang}
            onClose={closeDialog}
            onViewCart={goToCart}
          />
        </Suspense>
      )}
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
